import { AUTH_TOKEN } from "../react-admin/auth-provider";
import { $axios } from "../utils/axios";

export async function update_offer(
    applicationId: string,
    body: Record<string, any>,
) {
    return $axios({
        method: "put",
        url: `/admin/applications/${applicationId}/offer`,
        data: body,
        headers: {
            authorization: localStorage.getItem(AUTH_TOKEN)!,
        },
    });
}
